import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';
import { browserHistory } from 'react-router';
import createFragment from 'react-addons-create-fragment';
import _ from 'lodash';
import { getThemesV2, resetThemes, getThemesFiltering, onResetThemeKey } from '../../../actions/website/ThemeActions';
import { updateWeddingTheme, fetchWeddingThemeGroup, toggleWebsite } from '../../../actions/WeddingActions';
import CurrentThemeViewer from './CurrentThemeViewer';
import { showModal } from '../../../actions/ModalActions';
import ThemesFilter from './ThemesFilter';
import ThemeGroup from './ThemeGroup';
import scrollViewTo from '../../../util/scrollViewTo';
import { getClearClass } from '../../util/themeClearClass';
import WebsiteNav from '../../../components/common/header/SecondaryNav/SecondaryNav';
import { weddingWebsiteNavItems, manageNavItems } from '../../../components/common/header/SecondaryNav/secondaryNavData';
import '../../../stylesheets/pages/EditPage.less';
import NavItem from '../../common/ui/NavItem';

class Themes extends Component {
  constructor(props) {
    super(props);
    const { onboard } = this.props;
    this.state = {
      offset: 0,
      onboardActive: onboard,
      filterOptions: {},
      themeGroup: props.themeGroup,
      themeGroupTitle: props.themeGroupTitle
    };
    this.getMoreThemes = this.getMoreThemes.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.activateOnboard = this.activateOnboard.bind(this);
  }

  componentWillMount() {
    const { weddingTheme, getThemeGroup } = this.props;
    if (this.props.themes.busy) {
      return;
    }
    if (weddingTheme.key) {
      getThemeGroup(weddingTheme.key);
    }
  }

  componentDidMount() {
    const scrollToAnchor = () => {
      const { currentThemeKey, themeGroupKey } = this.props;
      const scrollElement = currentThemeKey;
      const backUpScrollElement = themeGroupKey;
      if (scrollElement) {
        const el = document.getElementById(scrollElement);
        if (el) {
          this.scrollTo(el);
        } else if (!el) {
          const themeGroupEl = document.getElementsByClassName(backUpScrollElement)[0];
          this.scrollTo(themeGroupEl);
        }
      }
    };
    setTimeout(scrollToAnchor, 10);
  }

  onFilterChange(filters) {
    const { filterThemes, loadThemes, unloadThemes } = this.props;
    unloadThemes();
    this.setState({
      filterOptions: filters,
      offset: 0
    }, () => {
      filterThemes(this.state.filterOptions.selectedColorKeys, this.state.filterOptions.hasMatchingInvitation);
      loadThemes(this.state.offset);
    });
  }

  getMoreThemes() {
    if (this.props.themes.busy) {
      return;
    }
    const { loadThemes } = this.props;
    this.setState({ offset: this.state.offset + 10 });
    loadThemes(this.state.offset);
  }

  activateOnboard() {
    this.setState({ onboardActive: false });
  }

  scrollTo(el) {
    const { resetThemeKey } = this.props;
    if (el) {
      scrollViewTo(el);
      window.scrollBy(0, -112);
      resetThemeKey();
    }
  }


  render() {
    const { themes, setWeddingTheme, weddingTheme, onboard, weddingSlug, themeGroupTitle, currentThemeKey, slug, openShare, shareInfo, pageKey, published, publishWebsite } = this.props;
    const resultCount = themes.result_count;
    const themeGroups = themes.theme_group_views;
    const themeList = [];
    const hasMatchingInvitation = true;

    if (themeGroups) {
      themeGroups.map((themeGroup, idx) => (
        themeList.push(
          createFragment({
            tile: <ThemeGroup currentTheme={currentThemeKey} themeGroup={themeGroup} weddingTheme={weddingTheme} setWeddingTheme={setWeddingTheme} onboard={onboard} weddingSlug={weddingSlug} />,
            clearFix: getClearClass(idx)
          })
        )
      ));
    }
    return (
      <div>
        <div>
          {!onboard &&
          <div>
            {
              window.zola.feature.newUnifiedNav ?
                <span className="visible-md-block visible-lg-block"><WebsiteNav slug={slug} pageKey={pageKey} shareInfo={shareInfo} navItems={weddingWebsiteNavItems} altActive={false} /></span> :
                <span className="visible-md-block visible-lg-block"><WebsiteNav slug={slug} pageKey={pageKey} shareInfo={shareInfo} navItems={manageNavItems} altActive={false} /></span>
            }
            <span className="hidden-md hidden-lg"><WebsiteNav slug={slug} pageKey={pageKey} shareInfo={shareInfo} navItems={weddingWebsiteNavItems} altActive={false} /></span>
            <div id="themes-nav-wrapper">
              <div className="content-top">
                <div className="row">
                  <div className="navbar-default">
                    <h1 className="page-heading col-sm-6">View Designs</h1>
                  </div>
                  {slug && (
                    <ul className="nav navbar-nav navbar-right visible-xs">
                      <NavItem to={`/wedding/${slug}/${!pageKey || pageKey === 'home' ? '' : pageKey}`} activeClassName="active" target="_blank">
                        <button type="button" className="btn btn-primary navbar-btn" >Preview Website</button>
                      </NavItem>
                      <NavItem to="" activeClassName="active">
                        <button type="button" className="btn btn-secondary navbar-btn" onClick={() => openShare(Object.assign({}, shareInfo, { slug }))}>Share Website</button>
                      </NavItem>
                    </ul>
                  )}
                  {slug && published && (
                    <ul className="nav navbar-nav navbar-right hidden-xs">
                      <NavItem to="" activeClassName="active">
                        <button type="button" className="btn btn-primary navbar-btn visible" onClick={() => openShare(Object.assign({}, shareInfo, { slug }))}>Share Website</button>
                      </NavItem>
                      <NavItem to={`/wedding/${slug}/${!pageKey || pageKey === 'home' ? '' : pageKey}`} activeClassName="active" target="_blank">
                        <button type="button" className="btn btn-secondary navbar-btn view" >View Website</button>
                      </NavItem>
                    </ul>
                  )}
                  {slug && !published && (
                    <ul className="nav navbar-nav navbar-right hidden-xs">
                      <NavItem to="" activeClassName="active">
                        <button type="button" className="btn btn-primary navbar-btn make-website-visible" onClick={() => publishWebsite(published)}>Make Website Visible</button>
                      </NavItem>
                      <NavItem to={`/wedding/${slug}/${!pageKey || pageKey === 'home' ? '' : pageKey}`} activeClassName="active" target="_blank">
                        <button type="button" className="btn btn-secondary navbar-btn">Preview Website</button>
                      </NavItem>
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div>
          }
        </div>
        <div className="theme-page">
          <div>
            <div id="current-theme-viewer-container">
              <CurrentThemeViewer theme={weddingTheme} themeGroupTitle={themeGroupTitle} />
            </div>
            <div className="below-fold-container">
              <div className="filter-container" id="themes-filter-container">
                <ThemesFilter onFilterChange={this.onFilterChange} hasMatchingInvitation={hasMatchingInvitation} />
              </div>
              <div className="col-md-10 col-lg-10 col-lg-offset-0 scroll-container">
                <div id="themes-container">
                  {resultCount > 0 &&
                    <div className="result-count"><p className="sans-text">{resultCount} Design{resultCount !== 1 ? 's' : null}</p></div>
                  }
                  {themes &&
                    <InfiniteScroll loadMore={this.getMoreThemes} hasMore={this.state.offset < resultCount} initialLoad={false} threshold={20}>
                      {themeList}
                    </InfiniteScroll>
                    }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Themes.propTypes = {
  themes: PropTypes.shape({
    theme_group_views: PropTypes.arrayOf(
      PropTypes.shape({})
    ),
    color_options: PropTypes.arrayOf(
      PropTypes.shape({})
    ),
    selected_color_keys: PropTypes.array,
    resultCount: PropTypes.number,
    limit: PropTypes.number,
    offset: PropTypes.number,
    busy: PropTypes.bool,
  }),
  themeGroup: PropTypes.shape({
    themes: PropTypes.arrayOf(
      PropTypes.shape({})
    ),
  }),
  weddingTheme: PropTypes.shape({}),
  themeGroupTitle: PropTypes.string,
  loadThemes: PropTypes.func.isRequired,
  filterThemes: PropTypes.func.isRequired,
  unloadThemes: PropTypes.func.isRequired,
  setWeddingTheme: PropTypes.func.isRequired,
  onboard: PropTypes.bool,
  weddingSlug: PropTypes.string,
  getThemeGroup: PropTypes.func.isRequired,
  currentThemeKey: PropTypes.string,
  resetThemeKey: PropTypes.func.isRequired,
  themeGroupKey: PropTypes.string,
  slug: PropTypes.string,
  shareInfo: PropTypes.shape({}),
  openShare: PropTypes.func,
  published: PropTypes.bool,
  pageKey: PropTypes.string,
  publishWebsite: PropTypes.func,
};

const mapStateToProps = state => (
  {
    themes: state.website.themeListing,
    weddingTheme: state.wedding.theme,
    onboard: !state.wedding.account.disable_website_onboarding,
    weddingSlug: state.wedding.wedding.slug,
    themeGroup: state.website.themeListing.themeDetails,
    themeGroupTitle: state.wedding.themeGroupTitle,
    currentThemeKey: state.website.themeListing.themeKey ? state.website.themeListing.themeKey : null,
    themeGroupKey: state.website.themeListing.themeGroupKey ? state.website.themeListing.themeGroupKey : null,
    slug: state.wedding.wedding.slug,
    // pageKey: ownProps.params.pageKey,
    shareInfo: Object.assign({}, _.pick(state.wedding.account, 'enable_passcode', 'passcode')),
    published: state.wedding.account.published

  }
);

const mapDispatchToProps = dispatch => (
  {
    loadThemes: (offset) => {
      dispatch(getThemesV2(offset));
    },
    getThemeGroup: key => dispatch(fetchWeddingThemeGroup(key)),
    filterThemes: (selectedColorKeys, hasMatchingInvitation) => {
      dispatch(getThemesFiltering(selectedColorKeys, hasMatchingInvitation));
    },
    unloadThemes: () => dispatch(resetThemes()),
    setWeddingTheme: (themeKey, e, onboard) => {
      e.preventDefault();
      dispatch(updateWeddingTheme(themeKey))
        .then(() => {
          if (onboard) {
            browserHistory.push('/wedding/manage/website/pages');
          }
        });
    },
    resetThemeKey: () => dispatch(onResetThemeKey()),
    openShare: (wedding) => {
      dispatch(showModal('SHARE', { wedding }, { size: 'md' }));
    },
    publishWebsite: (published) => {
      if (published) {
        dispatch(toggleWebsite(false));
      } else {
        dispatch(showModal('HIDE_PAGES', {}, { size: 'md' }));
      }
    }
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Themes);



/** WEBPACK FOOTER **
 ** ./src/components/manage/website/Themes.jsx
 **/